module.exports = __webpack_public_path__ + "static/media/13-aermel_kittel_brille.6c3e5dc6.jpg";